import React from 'react';
import { useSelector } from 'react-redux';

import { useActivate } from 'core/store/store';

import { authRoleSelector } from 'state/auth/selectors';
import { SignupActionType } from 'state/signup/actions';
import { signupStageSelector } from 'state/signup/selectors';
import { SignupStage } from 'state/signup/reducer';

import { CodeForm } from 'pages/Signup/components/CodeForm';
import { SignupForm } from 'pages/Signup/components/SignupForm';
import { SuccessForm } from 'pages/Signup/components/SuccessForm';

import { SignupVendorWarning } from './components/SignupVendorWarning';
import { UserRole } from 'types';

export const Signup = () => {
    useActivate(SignupActionType.ACTIVATE, SignupActionType.DEACTIVATE);
    const userRole = useSelector(authRoleSelector);
    const stage = useSelector(signupStageSelector);
    // if (userRole === UserRole.CUSTOMER) {
    //     return <SignupVendorWarning />;
    // }
    // else if (userRole === UserRole.VENDOR && !hasFake) {
    //     return <Redirect to={RoutePath.VENDOR_DASHBOARD} />;
    // }
    switch (stage) {
        case SignupStage.OFFER:
        case SignupStage.SUBMIT:
            return <SignupForm />;
        case SignupStage.CONFIRM:
            return <CodeForm />;
        case SignupStage.FINISHED:
            return <SuccessForm />;
    }
};
